import * as highcharts from "highcharts";
import { Component, h } from "preact";
// tslint:disable-next-line:no-var-requires
require("highcharts/modules/treemap")(highcharts);
// tslint:disable-next-line:no-var-requires
require("highcharts/modules/heatmap")(highcharts);

// tslint:disable-next-line:no-var-requires
const drilldown = require("highcharts/modules/drilldown");
drilldown(highcharts);

interface IProps {
  options: any;
}

export const TreeMapOpt = class extends Component<IProps> {
  private divElement?: HTMLDivElement;
  private chart?: Highcharts.Chart;
  private reflowIntervalHandle?: number;

  public componentDidMount() {
    this.createChart();

    this.reflowIntervalHandle = window.setInterval(() => {
      if (this.chart !== undefined) {
        this.chart.reflow();
      }
    }, 500);
  }

  public componentDidUpdate() {
    this.createChart();
  }

  // Destroy chart before unmount.
  public componentWillUnmount() {
    window.clearInterval(this.reflowIntervalHandle);
    if (this.chart) {
      this.chart.destroy();
    }
  }

  public render(props: IProps, state: {}) {
    return (
      <div
        id="container"
        style="height: 100%; width: 100%"
        ref={e => (this.divElement = e as HTMLDivElement)}
      />
    );
  }

  private createChart() {
    highcharts.setOptions({
      lang: {
        decimalPoint: ".",
        numericSymbols: [" K", " M", " G", " T", " P", " E"],
        thousandsSep: ",",
      },
    });
    if (this.chart) {
      this.chart.destroy();
    }
    this.chart = new highcharts.Chart(
      this.divElement as HTMLElement,
      this.props.options
    );
  }
};
